<template>
  <div class="interview-record">
    <div v-if="view && view_item">
      <div class="record-item">
        <div class="record-header">
          <span class="record-time">{{ view_item.created_at }}</span>
          <span class="record-score">总分：{{ view_item.all_score }}/300</span>
        </div>
        <div class="record-content">
          <div class="question-answer" v-for="(item, index) in [1, 2, 3]" :key="index">
            <div class="question">
              <h4>第{{ item }}题</h4>
              <audio controls :src="'/' + view[`item${item}_src`]" @play="pauseOtherAudios($event)"></audio>
              <div class="text-content">
                {{ view[`item${item}_txt`] }}
              </div>
              </div>
            <div class="answer" v-if="view_item[`v${item}_src`]">
              <div class="answer-header">回答</div>
              <audio controls :src="'/' + view_item[`v${item}_src`]" @play="pauseOtherAudios($event)"></audio>
              <div>{{ view_item[`v${item}_txt`] }}</div>
            
                
              
                <div>
                    
                    <div  class="score" >专业得分：</div>
                    <div v-for="(sv, sk) in scoreData[`score${item}`]['score']"
                        :key="`sk_${item}_${sk}`"
                    >
                        {{ sk }}：{{ sv }}/10
                    </div>
                    <div  class="score" >评价：</div>
                    {{ scoreData[`score${item}`]['comment'] }}
                </div>
                <div >
                    
                    <div  class="score" >表达得分：</div>
                    <div v-for="(sv, sk) in scoreData[`sound${item}`]['score']"
                        :key="`sk_${item}_${sk}`"
                    >
                        {{ sk }}：{{ sv }}/10
                    </div>
                    <div  class="score" >评价：</div>
                    {{ scoreData[`sound${item}`]['comment'] }}
                </div>
            
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-data">暂无面试记录</div>
  </div>
</template>

<script>
export default {
  name: 'InterviewRecord',
  props: {
    view: {
      type: Object,
      required: true
    },
    view_item: {
      type: Object,
      required: true
    }
  },
  computed: {
    scoreData() {
      const result = {};
      for (let i = 1; i <= 3; i++) {
        const scoreKey = `v${i}_score`;
        if (this.view_item[scoreKey]) {
          try {
            result[`score${i}`] = JSON.parse(this.view_item[scoreKey]);
          } catch (e) {
            console.error(`解析${scoreKey}失败:`, e);
            result[`score${i}`] = null;
          }
        }
        const soundKey = `v${i}_sound`;
        if (this.view_item[soundKey]) {
          try {
            result[`sound${i}`] = JSON.parse(this.view_item[soundKey]);
          } catch (e) {
            console.error(`解析${soundKey}失败:`, e);
            result[`soundKey${i}`] = null;
          }
        }
      }
      return result;
    }
  },
  methods: {
    pauseOtherAudios(event) {
      const audioElements = document.querySelectorAll('audio');
      audioElements.forEach(audio => {
        if (audio !== event.target) {
          audio.pause();
        }
      });
    }
  }
};
</script>

<style scoped>
.interview-record {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.record-time {
  color: #666;
  font-size: 14px;
}

.record-score {
  font-size: 16px;
  font-weight: bold;
  color: #409EFF;
}

.question-answer {
  margin-bottom: 30px;
}

.question, .answer {
  margin-bottom: 15px;
}

.question h4 {
  margin: 0 0 10px 0;
  color: #303133;
}

.text-content {
  margin-bottom: 10px;
  color: #606266;
}

.answer-header {
  font-size: 14px;
  color: #909399;
  margin-bottom: 10px;
}

.score {
  margin-top: 10px;
  color: #67C23A;
  font-weight: bold;
}

audio {
  width: 100%;
  margin: 10px 0;
}

.no-data {
  text-align: center;
  color: #909399;
  padding: 20px;
}
</style>